import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { includeFixedDigits } from '../../../util/utils';
import { clearComparisons } from '../../../actions/compareActions';
import ModalCloseButton from '../../shared/modalCloseButton/modalCloseButton';
import ScoreIndex from './scoreIndex/scoreIndex';
import './compareCard.scss';

class CompareCard extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        this.props.clearComparisons();
    }

    getCompareItems() {
        const { compareItems } = this.props;

        const itemKeys = Object.keys(compareItems);
        const parsedItems = itemKeys.map(key => Object.values(compareItems[key])[0]);

        return parsedItems;
    }

    render() {
        const compareItems = this.getCompareItems();

        let titles = [];
        let overallRatings = [];

        if (compareItems) {
            compareItems.forEach((item, idx) => {
                const text = item.title;
                const title = <h4 key={idx} id={idx}>{text}</h4>;
                titles.push(title);

                const overallRating = <div key={idx} id={idx}>Overall Rating {includeFixedDigits(item['overallRating'], 1)}</div>;
                overallRatings.push(overallRating);
            });
        }

        return (
            <div id='compare' className='modal-content'>
                <ModalCloseButton placement='outer'/>

                <div className="compare-container">
                    <header>
                        <h3>How these diets compare</h3>
                        <ModalCloseButton placement='inner'/>
                    </header>

                    <div className='content-container border'>
                        <div className='content'>
                            <div className='title'>
                                {titles}
                            </div>

                            <div className='overall-score'>
                                {overallRatings}
                            </div>

                            <ScoreIndex compareItems={compareItems} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        compareItems: state.compare
    };
};

const mapDispatchToProps = dispatch => {
    return {
        closeModal: () => dispatch(closeModal()),
        clearComparisons: () => dispatch(clearComparisons()),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CompareCard));